import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { GoogleAdWordsCopySource } from 'app/model/pipeline/copysource/google-adwords.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(GoogleAdWordsCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class GoogleAdWordsCopySourceAdapter extends CopySourceAdapter<
    GoogleAdWordsCopySource,
    Model.GoogleAdWordsSource
> {
    protected override async _toResource(copySource: GoogleAdWordsCopySource): Promise<Model.GoogleAdWordsSource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(GoogleAdWordsCopySource).name);
    }

    protected override async _toModel(
        resource: Model.GoogleAdWordsSource,
        copyActivity: CopyActivity
    ): Promise<GoogleAdWordsCopySource> {
        return this._toTabularModel(resource, copyActivity, GoogleAdWordsCopySource.MODEL);
    }
}
